module.exports = __webpack_public_path__ + "img/en_my.ff67214f.png";